const EXCURSION_TYPE_MARKER = 'Excursion Type:';
const NOT_SUPPORTED_MARKER = 'not supported';

// axiosCommon/stbApi wrap the backend message with an "errorRefId: <id>: " prefix
// and, in production, a ": ses_<sentinelSid>" suffix. Extract the canonical
// sentence instead of stripping known wrapper shapes, so any wrapper format
// (present or future) can't leak into the displayed message.
const EXCURSION_TYPE_NOT_SUPPORTED_PATTERN = /Excursion Type: ".*" not supported/;

const extractExcursionTypeNotSupportedMessage = (message) => {
  if (typeof message !== 'string') return message;
  const match = message.match(EXCURSION_TYPE_NOT_SUPPORTED_PATTERN);
  return match ? match[0] : message;
};

const deleteCacheErrorMessage =
  'Oops, Content Cache cannot be cleared. (It might be cleared already or please contact support for help)';

const deleteCacheMessages = (responseData) =>
  responseData && responseData.message ? responseData.message : deleteCacheErrorMessage;

const populateErrorMessage = (argHash) => {
  const { message, store } = argHash;
  let errorMessage = message;
  const { errorSid, sentinelEventSid } = store.state.common.apiErrorMessage;
  if (Boolean(errorSid) || Boolean(sentinelEventSid)) {
    errorMessage += `<p class="v-card__text debug-error-message mt-3">Debug Reference:</p>`;
    if (errorSid) {
      errorMessage += `<p class="v-card__text debug-error-message">errorSid: ${errorSid}</p>`;
    }
    if (sentinelEventSid) {
      errorMessage += `<p class="v-card__text debug-error-message">sentinelEventSid: ${sentinelEventSid}</p>`;
    }
  }

  return errorMessage;
};

export {
  EXCURSION_TYPE_MARKER,
  NOT_SUPPORTED_MARKER,
  extractExcursionTypeNotSupportedMessage,
  deleteCacheMessages,
  populateErrorMessage
};
